import { render, staticRenderFns } from "./contract-tap-to-phone.vue?vue&type=template&id=5e02c6db&scoped=true"
import script from "./contract-tap-to-phone.vue?vue&type=script&lang=js"
export * from "./contract-tap-to-phone.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=5e02c6db&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02c6db",
  null
  
)

export default component.exports